export function isString(arg: any): arg is string {
  return typeof arg === 'string';
}
